import React from 'react';

const Download = ({ className }) => (
  <svg
    className={className}
    width="17"
    height="15"
    viewBox="0 0 17 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.44455 9.66667L11.3334 6.77778M8.44455 9.66667V1V9.66667ZM8.44455 9.66667L5.55566 6.77778L8.44455 9.66667Z"
      stroke="white"
      strokeOpacity="0.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.22217 11.1111L1.67067 12.9058C1.74878 13.2183 1.9291 13.4957 2.18296 13.694C2.43683 13.8922 2.74967 13.9999 3.07178 14H13.817C14.1391 13.9999 14.452 13.8922 14.7058 13.694C14.9597 13.4957 15.14 13.2183 15.2181 12.9058L15.6666 11.1111"
      stroke="white"
      strokeOpacity="0.5"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Download;
